import SiteReference from "@/models/SiteReference";

const baseUrl = `https://openstreamflow.com`;

// TODO: NEEDS TEST! Was for real gonna do it, but the project is currently AFU
//       due to the ill-advised typescript conversion.
export default {

  _normalizeCapitalization(str: string): string {
    const lowercaseTrimmed: string = str.trim().toLowerCase();
    const wordz: Array<string> = lowercaseTrimmed.split(' ').map(term => {
      return `${term[0].toUpperCase()}${term.slice(1)}`;
    });
    return wordz.join(' ');
  },

  getSitePageTitle(siteReference: SiteReference): string {
    return `${this._normalizeCapitalization(siteReference.siteName)} | Stream flow For USGS Site ${siteReference.siteNumber} | OpenStreamflow`
  },

  getSitePageDescription(siteNumber: string, state: string): string {
    return `Current & historical streamflow data for USGS station #${siteNumber} in ${state.toUpperCase()} | Find river gauges by map or find by keyword | OpenStreamflow`
  },

  getHomePageTitle(): string {
    return `OpenStreamflow | USGS Streamflow App | River Gauge Map Search`;
  },

  getHomePageDescription(): string {
    return `Find USGS river gauges by keyword or map | view current & historical streamflow data for all USGS streamflow sites | OpenStreamflow`
  },

  getSearchPageTitle(searchTerm: string): string {
    return `OpenStreamflow search results for '${searchTerm}'`;
  },

  getSearchPageDescription(searchTerm: string): string {
    return `All USGS streamflow sites whose name contains the keyword '${searchTerm}'`;
  },

  getLocationSearchPageDescription(searchTerm: string): string {
    return `All USGS streamflow sites present on the map centered on location '${searchTerm}'`;
  },

  getCanonicalBase(): string {
    return `${baseUrl}`;
  },

}
